module.exports = function (done, value) {
  return { value: value, done: !!done };
};



//////////////////
// WEBPACK FOOTER
// /Users/apple/Documents/object/chinaicac-portal/node_modules/_core-js@2.6.12@core-js/modules/_iter-step.js
// module id = ../../../../_core-js@2.6.12@core-js/modules/_iter-step.js
// module chunks = polyfills